// 动画模块
const AnimationModule = (() => {
  // 注册 GSAP 插件
  gsap.registerPlugin(ScrollTrigger);

  // 获取每个类对应的动画配置
  // 获取每个类对应的动画配置
  function getAnimationOptions(element) {
    let options = {
      opacity: 0,
      x: 0,
      y: 0,
      duration: 1,
      delay: 0.2,
      scrollTriggerOptions: {
        trigger: element,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    };

    // 根据元素的类名设置不同的动画效果
    if (element.classList.contains('to-left')) {
      options.x = -100; // 向左滑动
    } else if (element.classList.contains('to-top')) {
      options.y = 30; // 从下到上滑动
    } else if (element.classList.contains('to-edge')) {
      options.x = -150; // 向左滑动更多
    } else if (element.classList.contains('slide-to-left')) {
      options.x = -200; // 向左滑动更大距离
    } else if (element.classList.contains('to-opacity')) {
      options.opacity = 0; // 透明度动画
    } else if (element.classList.contains('to-top1')) {
      options.y = -50; // 向上移动（不同的距离）
    } else if (element.classList.contains('text-top')) {
      options.y = -150; // 向上移动较大距离
    } else if (element.classList.contains('text-top-btn')) {
      options.y = -200; // 按钮向上移动
    } else if (element.classList.contains('slide-to-left-white')) {
      options.x = -300; // 白色滑动动画
    } else if (element.classList.contains('line-top')) {
      options.y = -50; // 线条向上移动
    }

    return options;
  }

  // 元素进入视口动画
  function animateOnScroll(selector) {
    gsap.utils.toArray(selector).forEach((element) => {
      const animationOptions = getAnimationOptions(element);

      gsap.from(element, {
        opacity: animationOptions.opacity,
        x: animationOptions.x,
        y: animationOptions.y,
        duration: 0.5,
        delay: animationOptions.delay,
        scrollTrigger: {
          trigger: element,
          start: 'top 100%',
          toggleActions: 'play none none none',
          markers: false,
        },
      });
    });
  }

  // 数字增长动画
  function animateNumber(selector, endValue, duration = 2) {
    const element = document.querySelector(selector);

    // 格式化数字的函数
    function formatNumber(number) {
      if (number >= 1000000) {
        return (number / 1000000).toFixed(1) + 'M'; // 大于等于 1M 时，转换为 M
      } else if (number >= 1000) {
        return (number / 1000).toFixed(1) + 'K'; // 大于等于 1K 时，转换为 K
      } else {
        return number; // 小于 1000 时，保持原数字
      }
    }

    // 如果结束值大于等于1000，直接设置格式化后的值
    const formattedEndValue = formatNumber(endValue);

    // 动画开始前，立即显示格式化后的数字（避免滚动动画）
    element.innerText = formattedEndValue;

    // 如果要滚动动画，使用 GSAP 来逐步更新数字
    gsap.to(element, {
      duration: duration,
      innerText: endValue,
      snap: { innerText: 1 },
      ease: 'power1.out',
      onUpdate: function () {
        // 在每次更新时格式化数字并显示
        element.innerText = formatNumber(Math.floor(this.targets()[0].innerText));
      },
    });
  }

  // 为文字添加包装和延迟效果
  function addTextAnimation(selector, delay = 0.1) {
    gsap.utils.toArray(selector).forEach((element, index) => {
      gsap.from(element, {
        opacity: 0,
        y: 20,
        duration: 1,
        delay: index * delay,
        scrollTrigger: {
          trigger: element,
          start: 'top 80%',
        },
      });
    });
  }

  // 滚动节流（可选）
  function throttle(func, limit) {
    let inThrottle;
    return function () {
      const args = arguments;
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  function getAnimationOptions(element) {
    let options = {
      opacity: 0,
      x: 0,
      y: 0,
      duration: 0.3,
      delay: 0.2,
      scrollTriggerOptions: {
        trigger: element,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    };

    // 根据元素的类名设置不同的动画效果
    if (element.classList.contains('to-left')) {
      options.x = -100; // 向左滑动
    } else if (element.classList.contains('to-top')) {
      options.y = 30; // 从下到上滑动
    } else if (element.classList.contains('to-edge')) {
      options.x = -150; // 向左滑动更多
    } else if (element.classList.contains('slide-to-left')) {
      options.x = -200; // 向左滑动更大距离
    } else if (element.classList.contains('to-opacity')) {
      options.opacity = 0; // 透明度动画
    } else if (element.classList.contains('to-top1')) {
      options.y = -50; // 向上移动（不同的距离）
    } else if (element.classList.contains('text-top')) {
      options.y = -150; // 向上移动较大距离
    } else if (element.classList.contains('text-top-btn')) {
      options.y = -200; // 按钮向上移动
    } else if (element.classList.contains('slide-to-left-white')) {
      options.x = -300; // 白色滑动动画
    } else if (element.classList.contains('line-top')) {
      options.y = -50; // 线条向上移动
    }

    return options;
  }

  // 初始化动画
  function init() {
    // 示例调用封装的动画方法
    animateOnScroll(
      '.to-left, .to-edge, .to-top, .slide-to-left, .to-opacity, .to-top1, .text-top, .text-top-btn, .slide-to-left-white, .line-top'
    );
    addTextAnimation('.text-top span');
  }

  // 返回模块中的方法以便调用
  return {
    init,
    animateOnScroll,
    animateNumber,
    addTextAnimation,
    throttle,
  };
})();

// 使用示例
$(document).ready(() => {
  AnimationModule.init(); // 初始化所有动画
});

/**
 * 视图滚动动画
 * 使用方法：
 * 1. 多元素
 * <div lt-scrollspy="target: .scroll-inview-item; y: 30;">
 *   <div class="scroll-inview-item">Item 1</div>
 *   <div class="scroll-inview-item">Item 2</div>
 *   <div class="scroll-inview-item">Item 3</div>
 * </div>
 *  参数：
 * target: 目标元素
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 *
 * 2. 单独元素
 * <div lt-scroll-inview="y: 30;">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 * </div>
 * 参数：
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 */
class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);

    // 处理多元素动画
    document.querySelectorAll('[lt-scrollspy]').forEach((container) => {
      const config = this.parseConfig(container.getAttribute('lt-scrollspy'));
      const targets = container.querySelectorAll(config.target);

      const originOverflow = container.style.overflow;
      container.style.overflow = 'initial';

      gsap.set(targets, {
        opacity: 0,
        x: config.x,
        y: config.y,
      });
      ScrollTrigger.batch(targets, {
        start: 'top 90%',
        // 分批处理
        batchMax: targets.length,
        // 批次间隔
        interval: 0.1,
        onEnter: (elements) => {
          gsap.to(elements, {
            opacity: config.opacity,
            x: 0,
            y: 0,
            duration: config.duration,
            ease: config.ease,
            stagger: {
              each: config.delay,
              from: 'start',
            },
            overwrite: true,
            onComplete: () => {
              const lastTarget = targets[targets.length - 1];
              const lastElement = elements[elements.length - 1];
              if (lastTarget === lastElement) {
                container.style.overflow = originOverflow;
              }
            },
          });
        },
      });
    });

    // 处理单独元素动画
    gsap.utils.toArray('[lt-scroll-inview]').forEach((element) => {
      const config = this.parseConfig(element.getAttribute('lt-scroll-inview'));
      gsap.set(element, {
        opacity: 0,
        x: config.x,
        y: config.y,
      });
      gsap.to(element, {
        scrollTrigger: {
          trigger: element,
          start: 'top 90%',
          toggleActions: 'play none none none',
        },
        opacity: config.opacity,
        x: 0,
        y: 0,
        duration: config.duration,
        ease: config.ease,
        overwrite: true,
      });
    });
  }

  // 解析配置
  parseConfig(attr) {
    // 默认配置
    const config = {
      target: '.scroll-inview-item',
      opacity: 1, // 目标透明度
      x: 0, // 初始 X 偏移
      y: 0, // 初始 Y 偏移
      duration: 0.6, // 动画持续时间
      delay: 0.15, // 每个元素的延迟时间
      ease: '', // 缓动函数
    };
    if (!attr) return config;
    // 解析属性字符串
    attr.split(';').forEach((item) => {
      const [key, value] = item.split(':').map((str) => str.trim());
      if (key && value) {
        // 转换数值类型的参数
        if (['x', 'y', 'duration', 'delay'].includes(key)) {
          config[key] = parseFloat(value);
        } else {
          config[key] = value;
        }
      }
    });
    return config;
  }

  // 清理方法
  destroy() {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  }
}
// 初始化视图滚动动画
$(document).ready(() => {
  new ScrollAnimations();
});
